export const useCompanionAvatars = () => {
  return [
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-01%201.png?alt=media&token=5b310ab9-d0b6-4002-a5c2-940db2a7336f",
      displayOrder: 1,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-03%201.png?alt=media&token=6d2227e8-3577-4ce4-a560-3138e2282f78",
      displayOrder: 2,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-04%201.png?alt=media&token=4513afa3-2f94-42ae-a83a-d3ec88a473f2",
      displayOrder: 3,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-05%201.png?alt=media&token=99218616-fe23-434a-af9a-e1ac9a6cf91f",
      displayOrder: 4,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-06%201.png?alt=media&token=88dbf16d-4678-4e00-b2a9-9f61b1bdba85",
      displayOrder: 5,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-07%201.png?alt=media&token=02bd1a53-71c9-4515-abe5-c570fcd171f3",
      displayOrder: 6,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-08%201.png?alt=media&token=b85b01fc-21fc-4503-a68d-a8ed26592241",
      displayOrder: 7,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-09%201.png?alt=media&token=65ab32aa-3e4d-4530-853c-38b4cbd97cd5",
      displayOrder: 8,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-10%201.png?alt=media&token=bdd4485b-328f-46eb-9a64-b7233a0ae052",
      displayOrder: 9,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-11%201.png?alt=media&token=68ccf7b0-57d0-4657-9cbf-bc7c3ec00679",
      displayOrder: 10,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-12%201.png?alt=media&token=111e8b26-3c66-45d2-b1c8-dc3afe8f4b7e",
      displayOrder: 11,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-13%201.png?alt=media&token=7a39e6f3-ac54-4729-b3ff-a5ded509d8e9",
      displayOrder: 12,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-14%201.png?alt=media&token=be3d5131-0051-4487-841b-f25c00b55a06",
      displayOrder: 13,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-15%201.png?alt=media&token=0c21c0bf-2af5-4acf-813d-6f386bb70a7e",
      displayOrder: 14,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-16%201.png?alt=media&token=e51a01af-4a83-41a4-ac57-7ac94b9e89d1",
      displayOrder: 15,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-17%201.png?alt=media&token=48dce2b8-4bba-4969-8138-2a57f1c96927",
      displayOrder: 16,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-18%201.png?alt=media&token=4041ad2f-846d-4cec-b13a-1483874f0b81",
      displayOrder: 17,
    },
    {
      href: "https://firebasestorage.googleapis.com/v0/b/iew-gradebook.appspot.com/o/assets%2Favatars%2FAvatar%20Ideas-19%201.png?alt=media&token=3c102542-5ad1-42b0-ace5-6769ed053401",
      displayOrder: 18,
    },
  ];
};
